import ZoomableImage, { IZoomableImageProps } from 'client/common/components/zoomable-image';

import React from 'react';

function DesktopZoomableImage(props: IZoomableImageProps) {

    return (
        <ZoomableImage {...props} />
    );
}

export default DesktopZoomableImage;
